import React, { Component } from "react";
import { withRequest } from "../../utils/request";

class Form extends Component {
    state = {
        grupos: [],
        almacenes: []
    };
    getTable = async (url = null) => {
        const table = await this.props.request(url);

        if (table.data) {
            this.setState({
                [url]: table.data,
                loading: false
            });
        }
    };
    render() {
        const { contacto, errors } = this.props;
        return (
            <div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Nombre/Empresa:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={contacto.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            RNC/Cédula:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='rnc'
                            name='rnc'
                            defaultValue={contacto.rnc}
                        />
                        {errors.rnc && (
                            <small className='help-blockParams form-Text'>
                                {errors.rnc[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Teléfono:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='telefono'
                            name='telefono'
                            defaultValue={contacto.telefono}
                        />
                        {errors.telefono && (
                            <small className='help-blockParams form-Text'>
                                {errors.telefono[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Celular:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='celular'
                            name='celular'
                            defaultValue={contacto.celular}
                        />
                        {errors.celular && (
                            <small className='help-blockParams form-Text'>
                                {errors.celular[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Email:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='email'
                            name='email'
                            defaultValue={contacto.email}
                        />
                        {errors.email && (
                            <small className='help-blockParams form-Text'>
                                {errors.email[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Encargado:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='encargado'
                            name='encargado'
                            defaultValue={contacto.encargado}
                        />
                        {errors.encargado && (
                            <small className='help-blockParams form-Text'>
                                {errors.encargado[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Tipo:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <select
                            type='text'
                            className='text-input form-control'
                            id='tipo'
                            name='tipo'
                            defaultValue={contacto.tipo}>
                            <option value='Suplidor'>Suplidor</option>
                            <option value='Cliente'>Cliente</option>
                        </select>
                        {errors.tipo && (
                            <small className='help-blockParams form-Text'>
                                {errors.tipo[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Dirección:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='direccion'
                            name='direccion'
                            defaultValue={contacto.direccion}
                        />
                        {errors.direccion && (
                            <small className='help-blockParams form-Text'>
                                {errors.direccion[0]}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRequest(Form);
